import { __awaiter } from "tslib";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import React, { useState, useEffect } from 'react';
import RegistrationForm from "./Components/RegistrationForm";
import ConfirmationStep from "./Components/ConfirmationStep";
import ModulesStep from "./Components/ModulesStep";
import Swal from 'sweetalert2';
const axios = require('axios').default;
const Registration = ({ vars }) => {
    const [page, setPage] = useState(0);
    const [formData, setFormData] = useState({
        selectedDays: 0,
        globalErrors: {
            service_email: false,
            service_phone: false,
            service_name: false,
            service_type: false,
            service_address: false,
            service_zipcode: false,
            service_city: false,
            service_registration_number: false,
            person_date: vars.date != null,
            person_last_name: false,
            person_first_name: false,
            person_email: false,
            person_mobile: false,
            person_function: false,
        },
        modulesRaw: {
            ids: {},
            modules: {}
        },
        modules: [],
        formations: [],
        service_email: "",
        service_phone: "",
        service_name: "",
        service_type: "",
        service_address: "",
        service_zipcode: "",
        service_city: "",
        service_registration_number: "",
        person_date: vars.date != null ? vars.date : "",
        person_last_name: "",
        person_first_name: "",
        person_email: "",
        person_mobile: "",
        person_function: "",
        correct_data: false,
        consent: false,
        is_validated: false,
        status: "await",
    });
    const pll = (label) => {
        if (attributes.dictionnary[label] !== void 0) {
            return attributes.dictionnary[label];
        }
        return label;
    };
    const [attributes, setAttributes] = useState({
        functions: null,
        dispositif: null,
        formation: null,
        formationId: vars.formationId,
        dispositifId: vars.dispositifId,
        dictionnary: {}
    });
    let loader = "";
    let isLoaded = Array.isArray(attributes.functions);
    // Load all functions for the current form
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            function getDispositif() {
                let formData = new FormData();
                formData.append("dispositif", attributes.dispositifId);
                return axios.post("/dispositif/get-by-id", formData).then((response) => {
                    if (response.status == 200) {
                        return response.data.data;
                    }
                });
            }
            function getFunctions() {
                if (attributes.formationId != null) {
                    let formData = new FormData();
                    formData.append("formation", attributes.formationId);
                    formData.append("isMultiple", "0");
                    return axios.post("/formations/functions/get-all", formData).then((response) => {
                        if (response.status == 200) {
                            return response.data.functions;
                        }
                    });
                }
                else {
                }
            }
            function getTranslations() {
                let formData = new FormData();
                formData.append("locale", "fr");
                return axios.post("/api/translations", formData).then((response) => {
                    if (response.status == 200) {
                        return response.data.translations;
                    }
                    else {
                        return [];
                    }
                });
            }
            Promise.all([getDispositif(), getFunctions(), getTranslations()])
                .then(function (results) {
                let dispositif = results[0];
                let functions = results[1];
                let dictionnary = results[2];
                if (dispositif.type == "multiple" && attributes.formationId == null) {
                    let formData = new FormData();
                    //
                    formData.append("formation", dispositif.formationsIds);
                    formData.append("isMultiple", "1");
                    //
                    axios.post("/formations/functions/get-all", formData).then((response) => {
                        if (response.status == 200) {
                            setAttributes(Object.assign(Object.assign({}, attributes), { dispositif: dispositif, functions: response.data.functions, dictionnary: dictionnary }));
                        }
                    });
                }
                else {
                    let formData = new FormData();
                    //
                    formData.append("formation", attributes.formationId);
                    //
                    axios.post("/formation/get-by-id", formData).then((response) => {
                        if (response.status == 200) {
                            setAttributes(Object.assign(Object.assign({}, attributes), { dispositif: dispositif, functions: functions, formation: response.data.data, dictionnary: dictionnary }));
                        }
                    });
                }
            });
            // setAttributes({ ...attributes, functions: personFunctions, dispositif: dispositifData });
        });
        fetchData();
        // Only apply when all is loaded and after page changed
        if (isLoaded) {
            $.scrollTo("#registration", 500);
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [page]);
    const componentList = [
        React.createElement(ModulesStep, { attributes: attributes, formData: formData, setFormData: setFormData, page: page, setPage: setPage, pll: pll }),
        React.createElement(RegistrationForm, { attributes: attributes, formData: formData, setFormData: setFormData, page: page, setPage: setPage, pll: pll }),
        React.createElement(ConfirmationStep, { attributes: attributes, formData: formData, setFormData: setFormData, page: page, setPage: setPage, pll: pll })
    ];
    const handleSubmit = (e) => {
        e.preventDefault();
        let postData = new FormData();
        postData.append("modules", formData.modules);
        postData.append("service_email", formData.service_email);
        postData.append("service_phone", formData.service_phone);
        postData.append("service_name", formData.service_name);
        postData.append("service_type", formData.service_type);
        postData.append("service_address", formData.service_address);
        postData.append("service_zipcode", formData.service_zipcode);
        postData.append("service_city", formData.service_city);
        postData.append("service_registration_number", formData.service_registration_number);
        postData.append("person_date", formData.person_date);
        postData.append("person_last_name", formData.person_last_name);
        postData.append("person_first_name", formData.person_first_name);
        postData.append("person_email", formData.person_email);
        postData.append("person_mobile", formData.person_mobile);
        postData.append("person_function", formData.person_function);
        postData.append("correct_data", formData.correct_data);
        postData.append("consent", formData.consent);
        postData.append("status", formData.status);
        Swal.fire({
            icon: 'info',
            title: '',
            html: pll("currentlySendingIformations"),
            showConfirmButton: false,
            allowOutsideClick: false
        });
        axios.post("/module/subscription/add-participant", postData).then((response) => {
            if (response.status == 200) {
                if (response.data.success == true) {
                    Swal.fire({
                        icon: 'success',
                        title: '',
                        html: "<h2>Succès !</h2>" + response.data.message,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        timer: 8000,
                        timerProgressBar: true,
                        willClose: () => {
                            document.location.reload();
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: '',
                        html: "<h2>Erreur !</h2>" + response.data.message,
                        showConfirmButton: true,
                        allowOutsideClick: true
                    });
                }
            }
        });
    };
    //
    if (!isLoaded)
        loader = (React.createElement("div", { className: "loader" }, "Chargement en cours..."));
    return (React.createElement("div", { className: `registration-wrapper ${isLoaded ? "loaded" : "loading"}` },
        loader,
        React.createElement("div", { className: "content" }, isLoaded ? React.createElement("form", { onSubmit: handleSubmit }, componentList[page]) : "")));
};
$(document).ready(() => {
    const rootElement = document.getElementById("rootregistration");
    if ($(rootElement).length) {
        const root = createRoot(rootElement);
        const vars = {
            dispositifId: $(rootElement).attr("data-dispositif"),
            date: $(rootElement).attr("data-date") !== void 0 ? $(rootElement).attr("data-date") : null,
            formationId: $(rootElement).attr("data-formation") !== void 0 ? $(rootElement).attr("data-formation") : null,
        };
        root.render(React.createElement(Registration, { vars: vars }));
    }
});
